import React, {useContext, useEffect} from "react";
import "./loading.css";
import { StateContext } from "../App";

function Loading() {
    const { state, dispatch } = useContext(StateContext)

    useEffect(() => {
        
        const loader = document.querySelector(".loader-back")
        if (state.loading) {
            loader.style.display = "block";
        } else {
            loader.style.display = "none"
        }

    }, [state.loading])
    

  return (
    <div id="loading">
      <div className="loader-back">
            <div className="background-loader">
                <div className="lds-circle"><div></div></div>
            </div>
        </div>
    </div>
  );
}

export default Loading;
